import { BaseContainer, IContainer } from '../../../containers';
import { ServicesType } from '../services/ServicesType';
import { SetServiceDependencies } from '../types';

export type ContainersType = {
  authRefreshContainer: IContainer;
  accessControlContainer: IContainer;
};

export default class ContainersInitializer {
  public static instantiate(services: ServicesType): ContainersType {
    const authRefreshContainer = new BaseContainer();

    const containers: ContainersType = {
      authRefreshContainer,
      accessControlContainer: services.accessControlContainer
    };

    return containers;
  }

  public static async resolveDependencies({
    services,
    containers
  }: SetServiceDependencies): Promise<void> {
    // 1. Setting up dependencies for Auth container
    const authRefreshContainer: IContainer = containers.authRefreshContainer;

    if (services?.consentService) {
      authRefreshContainer.addService(services.consentService);
    }
    if (services?.userService) {
      authRefreshContainer.addService(services.userService);
    }
  }
}
